export default __webpack_public_path__ + "static/media/943.085f5984.svg";